export var VisuallyHiddenTestIds = {
    /** Test ID to grab the root element */
    ROOT: 'hawkins-visually-hidden-root',
};
//# sourceMappingURL=visuallyHidden.testids.js.map